import React from 'react';
import './styles/App.scss';
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import AppRouter from './AppRouter';

import { store, persistor } from './app/store';

const App = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ConfigProvider
                    theme={{
                        token: {
                            colorPrimary: '#8c54fc',
                            colorBgLayout: '#f6f5fb',
                            colorTextHeading: '#1d1a2e',
                            colorLink: '#7442e8',
                            colorLinkHover: '#8c54fc',
                            borderRadius: 8,
                        },
                    }}
                >
                    <AppRouter />
                </ConfigProvider>
            </PersistGate>
        </Provider>
    );
};

export default App;